export const gameFeed = {
  gameFeed: "Novedades",
  gameFeedTitle: "Novedades",
  gameFeedLoading: "Cargando juego...",
  gameFeedLike: "Me gusta",
  gameFeedUnlike: "Ya no me gusta",
  gameFeedLikeSingular: "me gusta",
  gameFeedLikePlural: "me gusta",
  gameFeedComments: "Comentarios",
  gameFeedNoComments: "Aún no hay comentarios. ¡Sé el primero!",
  gameFeedAddComment: "Agrega un comentario...",
  gameFeedCommentModerated:
    "Tu comentario no fue publicado porque va en contra de las políticas de la plataforma. Por favor, mantén los comentarios respetuosos.",
  gameFeedCommentSupportRedirect:
    "Para consultas sobre retiros o pagos, por favor contacta a nuestro equipo de soporte. Esta sección es solo para comentarios sobre el juego.",
  gameFeedPost: "Publicar",
  gameFeedDelete: "Eliminar",
  gameFeedLoginToComment: "Inicia sesión para comentar",
  gameFeedLoginToLike: "Inicia sesión para dar me gusta",
  gameFeedReply: "Responder",
  gameFeedReplyPlaceholder: "Escribe una respuesta...",
  gameFeedViewReplies: "Ver respuestas ({{count}})",
  gameFeedViewMoreReplies: "Ver más respuestas",
  gameFeedHideReplies: "Ocultar respuestas",
  gameFeedEndOfFeed: "¡Ya viste todos los juegos!",
  gameFeedCloseGame: "Cerrar juego",
  gameFeedExpandGame: "Expandir juego a pantalla completa",
  gameFeedDeposit: "Depositar",
  gameFeedBadgeHot: "En llamas",
  gameFeedBadgeNew: "Nuevo",
  gameFeedBadgeBigWinner: "Gran premio",
  gameFeedSwipeForAnotherGame: "Desliza aquí para otro juego",
  providerProfileBack: "Volver",
  providerProfileGames: "Juegos",
  providerProfileFollowers: "Seguidores",
  providerProfileFollow: "Seguir",
  providerProfileFollowing: "Siguiendo",
  providerProfileGridView: "Vista de cuadrícula",
  providerProfileListView: "Vista de lista",
  providerProfileNoGames: "Aún no hay juegos disponibles de este proveedor.",
  providerProfileClose: "Cerrar",
  providerProfilePlayGame: "Jugar",
  providerDescDefault: "Proveedor de juegos de casino en línea.",
  providerDescPragmatic:
    "Líder mundial en slots y juegos en vivo. Creadores de Gates of Olympus, Sweet Bonanza y Wolf Gold.",
  providerDescBgaming: "Estudio innovador de iGaming con slots provably fair, mecánicas únicas y diseño vibrante.",
  providerDescEvoplay: "Pioneros en juegos 3D y gamificación. Experiencias inmersivas con narrativas cinematográficas.",
  providerDescHacksaw: "Especialistas en raspaditos digitales y slots de alta volatilidad con ganancias extremas.",
  providerDescEvolution:
    "Nº1 en casino en vivo. Ruleta, blackjack, game shows y experiencias interactivas en tiempo real.",
  providerDescPixmove: "Estudio emergente con juegos arcade-casino híbridos y mecánicas de skill gaming.",
  providerDescUpgaming: "Proveedor de slots clásicos y modernos con jackpots progresivos y bonus features.",
  providerDescEndorphina: "Slots premium con temáticas culturales, alta calidad gráfica y matemáticas precisas.",
  providerDescBetby: "Plataforma líder en apuestas deportivas con cobertura de +30.000 eventos mensuales.",
  providerDescTada: "Estudio asiático con slots coloridos, multiplicadores masivos y mecánicas adictivas.",
  providerDescGamingcorps: "Desarrollador sueco de slots y juegos de mesa con enfoque en calidad y fair play.",
  providerDescKagaming: "Proveedor asiático con amplio catálogo de slots temáticos, pesca y juegos de mesa.",
  gameFeedFilterTitle: "Filtros",
  gameFeedFilterAll: "Todos",
  gameFeedFilterTopPlayed: "Top 10",
  gameFeedFilterTournament: "Torneo",
  gameFeedFilterDrop: "Drop",
  gameFeedFilterRace: "Carrera",
  gameFeedFilterSectionType: "Tipo de feed",
  gameFeedFilterSectionProvider: "Proveedor",
  gameFeedFilterSectionFeatures: "Características",
  gameFeedFilterSelectProviderFirst: "Selecciona un proveedor para activar características",
  gameFeedFilterClear: "Limpiar filtros",
  gameFeedFilterNoResults: "No hay juegos con estos filtros",
  gameFeedFilterShowMore: "Ver más",
  gameFeedFilterShowLess: "Ver menos",
  gameFeedFilterNoGamesType: '{{provider}} no tiene juegos "{{type}}"',
  gameFeedFilterNoFeature: "{{provider}} no tiene {{feature}} activo",
  gameFeedFilterAccept: "Aceptar",
  storyTopGamesTitle: "Los 3 más jugados de {{provider}}",
};
